import { ActionBar, RowsSelected } from "@/components/shared/tables/ActionBar";
import { Button } from "@/components/ui/button";
import { useAccountsDataContext } from "./accounts-data-provider";

import { useAccountsTableInstanceContext } from "./table-instance-provider";

export const AccountsTableActionBar = () => {
  const { table, setRowSelection } = useAccountsTableInstanceContext();
  const { deleteAccount, refetch } = useAccountsDataContext();
  const handleDelete = async () => {
    setRowSelection([]);
    await Promise.all(
      selectedAccountIds.map(async (id) => await deleteAccount(id)),
    );
    await refetch();
  };

  const selectedRows = table ? table.getFilteredSelectedRowModel().rows : [];
  const selectedAccountIds: string[] =
    selectedRows.length > 0
      ? selectedRows.map((row) => row.original?.accountId)
      : [];

  const allRows = table ? table.getFilteredRowModel().rows : [];

  if (selectedRows.length <= 0) return null;

  return (
    <ActionBar className="absolute">
      <RowsSelected
        selectedRowsLength={selectedRows.length}
        totalRowsLength={allRows.length}
        onDeselectAll={() => table?.resetRowSelection(true)}
      />
      <Button variant={"outline"} onClick={() => handleDelete()}>
        Löschen
      </Button>
    </ActionBar>
  );
};
